export class ForkliftScreenDto {
    public gateId: string = '';
    public columnLeftView: boolean = false;

    public static buildEmpty(): ForkliftScreenDto {
        return new ForkliftScreenDto();
    }

    public static toJson(dto: ForkliftScreenDto): string {
        return JSON.stringify(dto);
    }

    public static fromJson(json: string): ForkliftScreenDto {
        if (!json) return ForkliftScreenDto.buildEmpty();
        try {
            return Object.assign(new ForkliftScreenDto(), JSON.parse(json));
        } catch {
            return ForkliftScreenDto.buildEmpty();
        }
    }
}
